import React from "react";
import ChatComp from "../../components/chat";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";

export default function Chat() {
  return (
    <>
      <div className="container-fluid px-5 py-2">
        <div className="row align-items-center">
          <div className="col-md-12">
            <div className="logo">
              <Link to={-1}>
                <img src={logo} alt="Logo" width={130}/>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <ChatComp />
    </>
  );
}
